import { CallScreening } from "@/components/call-screening";
import { queueCallscreeningQueryOptions, queueQueryOptions } from "@/server/queues";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/_dashboard/queues/$queueId/call-screening")({
  component: RouteComponent,
  beforeLoad: ({ location, params }) => {
    const search = (location as any).search || {};
    if (!search.tab) {
      throw redirect({
        to: "/queues/$queueId/call-screening",
        params: { queueId: params.queueId },
        replace: true,
        search: { ...search, tab: "rules" },
      });
    }
  },
  loader: async ({ context, params }) => {
    return {
      crumb: "Call Screening",
    };
  },
});

function RouteComponent() {
  const { queueId } = Route.useParams();
  const queueQuery = useQuery(queueQueryOptions(Number(queueId)));
  const queue = queueQuery.data as { name?: string } | undefined;
  const queueCallscreeningQuery = useQuery(queueCallscreeningQueryOptions(Number(queueId)));
  const queueCallscreeningData = queueCallscreeningQuery.data as
    | {
        incoming?: { modify: string; black: string; white: string };
        outgoing?: { modify: string; black: string; white: string };
      }
    | undefined;

  useEffect(() => {
    if (!queueId) return;
    void queueQuery.refetch();
    void queueCallscreeningQuery.refetch();
  }, [queueId, queueQuery.refetch, queueCallscreeningQuery.refetch]);

  return (
    <CallScreening
      resourceId={Number(queueId)}
      callscreeningData={queueCallscreeningData}
      resource={queue}
      resourceType="queue"
      loading={queueCallscreeningQuery.isLoading}
    />
  );
}
